var _path, _path2, _path3, _path4, _path5, _path6;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgReseauAiBreak(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Pastille_AI",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 177 177",
    style: {
      enableBackground: "new 0 0 177 177"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M157.84,69.51l-48.57,17.68l39.82,39.83C159.67,110.41,163.34,89.63,157.84,69.51z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M48.05,147.71c18.45,12.57,42.48,16.4,65.06,8.18c5.03-1.83,9.73-4.18,14.06-6.95l-22.01-22.02L48.05,147.71z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M99.52,39.77c3.1-1.13,6.54,0.48,7.67,3.58c1.13,3.11-0.48,6.54-3.58,7.67l-22.37,8.12l18.7,18.7l53.82-19.59 c-15.47-33.61-54.4-50.29-89.79-37.41c-5.03,1.83-9.74,4.17-14.07,6.94L71.89,49.8L99.52,39.77z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M19.4,68.86l20.33-7.38L27.98,49.72C24.21,55.65,21.31,62.1,19.4,68.86z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M48.38,109.35c-0.68,0.25-1.37,0.36-2.05,0.36c-2.45,0-4.74-1.51-5.63-3.94c-1.13-3.11,0.47-6.54,3.58-7.67l23.51-8.56 L49.08,70.82L16.93,82.5c-0.83,10.02,0.42,20.38,4.09,30.45c3.66,10.04,9.33,18.76,16.38,25.9l58.42-21.26L77.13,98.89L48.38,109.35 z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M160.38,167.73c-1.92,0-3.84-0.73-5.3-2.2L11.38,21.8c-2.93-2.93-2.93-7.68,0-10.61c2.93-2.93,7.68-2.93,10.61,0 l143.7,143.73c2.93,2.93,2.93,7.68,0,10.61C164.22,167,162.3,167.73,160.38,167.73z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReseauAiBreak);
export default __webpack_public_path__ + "static/media/reseau_ai_break.93f081a3719c7c52e08e8b4e36adb25c.svg";
export { ForwardRef as ReactComponent };